import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const DiscoverSection = () => {
  return (
    <section className="discover_all">
      <Container>
          <div className="discover_box">
            <Row>
              <Col md={6} className='p-0'>
                <div className="discover_boximg aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                  <LazyLoadImage src={`${ImageUrl}theme/tokyo/grid2-12x.jpg`} className="img-responsive" alt="img" />
                </div>
              </Col>

              <Col md={6} className='p-0 pl-md-3 pl-0'>
                <div className="discover_boxcontent aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                  <div className="discover_boxinner">
                    <h2>4C's of Diamond</h2>
                    <div className="discover_btn">
                      <Link className="main_button" to="/diamond-education#loosediamonds">Learn More</Link>
                    </div>

                  </div>					

                  <div className="discover_boximg2 aos-init" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="1500">
                    <LazyLoadImage src={`${ImageUrl}theme/tokyo/grid2-22x.jpg`} className="img-responsive" alt="img" />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
      </Container>
		</section>
  )
}

export default DiscoverSection